import requestBuilder from '@/requestBuilder'
import paramsBuilder from '@/paramsBuilder'

const apiFolder = {
  getUserFiles (params) {
    return requestBuilder.get({ path: '/items/user', params: paramsBuilder(params) })
  },
  putUpdateFolderRequest (folderId, body) {
    return requestBuilder.put({ path: `/folders/${folderId}`, body })
  },
  getFolderFiles (folderId, params) {
    return requestBuilder.get({ path: `/folders/${folderId}/items`, params: paramsBuilder(params) })
  },
  getFolderInfo (folderId) {
    return requestBuilder.get({ path: `/folders/${folderId}` })
  },
  createFolder (body) {
    return requestBuilder.post({ path: '/folders', body })
  },
  moveFolder ({ folderId, parentItemId }) {
    return requestBuilder.put({ path: `/folders/${folderId}/move/${parentItemId}` })
  },
  deleteFolder (folderId) {
    return requestBuilder.delete({ path: `/folders/${folderId}` })
  }
}

export default apiFolder
